export default __webpack_public_path__ + "assets/images/78ce200835b03ac62fee0e83ed80bb3b.png";